// extracted by mini-css-extract-plugin
export default {"footer":"footer__kmcya","links":"links__W8NJX","legal":"legal__piyD1","disclaimer":"disclaimer__o5CO8"};